import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Auth } from 'store/auth/actions';
import { isAuthenicatedSelector, pendingSelector } from 'store/auth/selectors';
import { LoginForm } from './components/LoginForm';

import './style.scss';

const LoginPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useSelector(isAuthenicatedSelector);
  const pending = useSelector(pendingSelector);

  useEffect(() => {
    dispatch(Auth.authErrorAction(null));
  }, [dispatch]);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  const handleReset = () => {
    history.push('/reset');
  };

  const handleRegister = () => {
    history.push('/register');
  };

  const handleSubmit = ({ username, password }) => {
    dispatch(
      Auth.signIn({
        email: username,
        password,
      })
    );
  };

  return (
    <div className="login-content">
      <LoginForm pending={pending} title="Авторизация" onSubmit={handleSubmit} />
      <div className="login-footer">
        <div className="login-link" onClick={handleReset}>
          Забыли пароль?
        </div>
        &bull;
        <div className="login-link" onClick={handleRegister}>
          Регистрация
        </div>
      </div>
    </div>
  );
};

export { LoginPage };
